module.exports = __webpack_public_path__ + "img/hourglass.0545abe0.svg";